var map = {
	"./LAZADA_ID.svg": "1ca5",
	"./MANUAL_ID.svg": "0cb5",
	"./SHOPEE_ID.svg": "f02e",
	"./TIKTOK_ID.svg": "e272",
	"./TOKOPEDIA_ID.svg": "ea25",
	"./WOO_COMMERCE_ID.svg": "9138",
	"./armezza.svg": "1c72",
	"./balanja.svg": "46c3",
	"./cod.svg": "cfe8",
	"./google.svg": "7f6a",
	"./heykama.svg": "b8d6",
	"./message.svg": "c360",
	"./pre_sale.svg": "aeff",
	"./printed_express.svg": "fe37",
	"./qiwari.svg": "af08"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7769";